import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import UpgradeBanner from './UpgradeBanner';
import FeedbackButton from './FeedbackButton';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="main-layout">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-overlay"
        />
      )}
      
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Main content */}
      <div className="md:ml-64 min-h-screen flex flex-col">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Bannière d'upgrade */}
        <UpgradeBanner />
        
        <main className="flex-1 p-6 md:p-8 lg:p-12 animate-fade-in">
          <Outlet />
        </main>
      </div>
      
      {/* Feedback Button */}
      <FeedbackButton />
    </div>
  );
};

export default Layout;
